export class ExtendMap<K, V> extends Map<K, V> {
  getOrDefault(key: K, defaultValue: V): V {
    const result = this.get(key);
    if (result === undefined) {
      return defaultValue;
    }
    return result;
  }
}
